import { render } from "./ColorPicker.vue?vue&type=template&id=2fdcb286"
import script from "./ColorPicker.vue?vue&type=script&lang=js"
export * from "./ColorPicker.vue?vue&type=script&lang=js"
script.render = render

export default script